module.exports = {"610111001":"纺织城街道","610111002":"十里铺街道","610111003":"红旗街道","610111004":"席王街道","610111005":"洪庆街道","610111006":"狄寨街道","610111007":"灞桥街道","610111008":"新筑街道","610111009":"新合街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610111.json
// module id = 2915
// module chunks = 0